import { createFileRoute, redirect } from '@tanstack/react-router';

/* Il changelog è diventato le circolari il 26-10-2026 (task 2055): le note di rilascio sono
   circolari con la versione, e hanno la loro pagina. Tiene vivi i vecchi link. */
export const Route = createFileRoute('/_app/changelog')({
  beforeLoad: () => { throw redirect({ to: '/circulars/release-notes', replace: true }); },
});
